import axios from 'axios';

export const fetchConfig = async () => {
  const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/config`);
  return response.data;
}

export const updateConfig = async ({orangeThreshold, redThreshold, minIctrStart, everyIctrIncrease, maxDiffBlockRecommendation}) => {
  const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/config`, {
    orange_alert_threshold: orangeThreshold,
    red_alert_threshold: redThreshold,
    min_ictr_start: minIctrStart,
    every_ictr_increase: everyIctrIncrease,
    max_diff_block_recommendation: maxDiffBlockRecommendation
  });
  return response.data;
};
